// Roles constants
export const ROLE_PROJECT_MANAGER = 'PROJECT MANAGER';
export const ROLE_WORKER = 'WORKER';
export const ROLE_ADMIN = 'ADMIN';

export const PERMISSION_LEVEL = [
    1,2,3,4,5
]
